import { Link, createFileRoute, type SearchSchemaInput } from '@tanstack/react-router'
import {increaseCreditBank} from '@/queries/payment'
import {useEffect, useRef, useState} from 'react'
import {toast} from 'sonner'
import {Card, CardTitle, CardHeader, CardContent} from '@/components/ui/card'
import {Button} from '@/components/ui/button'
import {Separator} from '@/components/ui/separator'
// import {Label} from '@/components/ui/label'
import {Input} from '@/components/ui/input'
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import {useForm} from 'react-hook-form'
import {z} from 'zod'
// import {NumericFormat} from 'react-number-format'
import {zodResolver} from '@hookform/resolvers/zod'
import {Check, Loader2, X} from 'lucide-react'
// import {wordifyRialsInTomans} from '@/utils/wordify'
import persianJs from '@/lib/persian'
import {Dialog, DialogTitle, DialogContent, DialogFooter} from '@/components/ui/dialog'
import {RadioGroup, RadioGroupItem,} from '@/components/ui/radio-group'
import { useMutation } from '@tanstack/react-query'
import { useStore } from '@tanstack/react-store'
import userStore from '@/stores/user-store'
import {useEchoPublic} from '@laravel/echo-react'
import type { Setting } from '@/types'
import { authCheck } from '@/queries/auth'
import { wordifyRialsInTomans } from '@/lib/wordify'

const paymentBankSchema = z.object({
  value: z
    .number()
    // .required('وارد کردن مبلغ الزامی است')
    .gte(200000, 'مبلغ وارد شده نباید کمتر از ۲۰۰٫۰۰۰ ريال باشد')
    .lte(2000000000, 'مبلغ وارد شده نمی تواند بیشتر از ۲٫۰۰۰٫۰۰۰٫۰۰۰ ريال باشد'),
  bank: z.string(),
})


export const Route = createFileRoute('/payment/bank/')({
  validateSearch: (search?: Record<string, unknown> & SearchSchemaInput): {refCode: string, ok: boolean | null} | null => {
    
    if (search && Object.keys(search).length > 0) {

      return {
        refCode: search.refCode as string || '',
        ok: search.ok as boolean || null, 
      }
    } 
    return null
  },
  component: PaymentBank,
})



function PaymentBank () {
  const {user: currentUser} = useStore(userStore)
  const form = useRef<HTMLFormElement>(null)
  const mellatFrom = useRef<HTMLFormElement>(null)
  const [formData, setFormData] = useState<any>({token: '', RedirectURL: ''})
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const returnUrl = `${location.origin}/payment/bank/`
  const [result, setResult] = useState(false)
  const searchParams = Route.useSearch()
  const navigate = Route.useNavigate()
  const authCheckMutation = useMutation({
    mutationFn: () => authCheck(),
    mutationKey: ['authCheck']
  })
  // const [settings, setSettings] = useState<any>({})
  const {setting} = useStore(userStore)
  const settings = setting
  
  useEchoPublic('settings', '.SettingUpdated', (e: {settings: Setting}) => {
    userStore.setState(state => ({...state, setting: e.settings}))
    increaseForm.setValue('bank', e.settings.bank_default)
  })

    useEffect(() => {
    console.log(settings)
    authCheckMutation.mutate()
    if (searchParams?.refCode) {
      setResult(true)
    }
  }, [])

  useEffect(()=> {
    if (!authCheckMutation.isPending && authCheckMutation.data) {
      const data = authCheckMutation.data?.data
      if (data.setting) {
        userStore.setState(state => ({...state, setting: data.setting.settings}))
        console.log(data.setting)
        increaseForm.setValue('bank', data.setting.settings.bank_default)
      }
    }
  }, [authCheckMutation.data])
  
  
  const samanStatus = settings && settings.bank_saman_status !== null
  const mellatStatus = settings && settings.bank_mellat_status !== null


  useEffect(() => {
    if (searchParams?.refCode) {
      setResult(true)
    }
  }, [])

  const increaseForm = useForm<z.infer<typeof paymentBankSchema>>({
    resolver: zodResolver(paymentBankSchema),
    values: {
      value: 0,
      bank: 'saman',
    },
    mode: 'onChange',
  })

  const bankIncreaseMutation = useMutation({
    mutationFn: (data: {value: any; bank: string}) =>
      increaseCreditBank(data.value, currentUser?.mobile || '', returnUrl, data.bank),
    onSuccess(data, variables) {
      setFormData({...data.data[0]})
      toast.success('پرداخت با موفقیت ایجاد شد درحال انتقال به درگاه ...')
      setTimeout(() => {
        if (variables.bank === 'mellat') {
          mellatFrom.current?.requestSubmit()
        } else {
          form.current?.requestSubmit()
        }
      }, 1000)
    },
    onError() {
      toast.error('خطایی در انتقال به درگاه رخ داده است ُ مجددا تلاش فرمایید...')
    },
  })

  const onSubmit = (values: z.infer<typeof paymentBankSchema>) => {
    bankIncreaseMutation.mutate(values)
  }

  const openModal = () => {
    setShowConfirmModal(true)
  }

  const increaseValue = (value: number) => {
    increaseForm.setValue('value', Number(increaseForm.getValues('value') + value))
  }

  if (result) {
    return (
      <>
        <div className='border border-white/10 bg-black/5 dark:bg-white/5 rounded-lg flex flex-col relative p-4 overflow-hidden'>
          <div className='flex justify-between pb-2 border-b border-black/5 dark:border-white/5 mb-2'>
            <div className='card-title'>نتیجه پرداخت</div>
          </div>

          <div className='flex flex-col justify-center items-center gap-4'>
            {searchParams?.ok ? (
              <>
                <Check className='text-green-500 text-4xl' />
                <p>پرداخت با موفقیت انجام شد</p>
                <p>کد پیگیری‌: {searchParams?.refCode}</p>
                <Link to={'/'} search={{t: '', r: ''}}>
                  <Button className='bg-emerald-500 rounded-lg px-4 py-2'>
                    بازگشت و خرید شارژ
                  </Button>
                </Link>
              </>
            ) : (
              <>
                <X className='text-red-500 text-4xl' />
                <p>خطایی در پرداخت رخ داده است</p>

                <p>کد پیگیری‌: {searchParams?.refCode}</p>
                <Button
                  className='bg-red-500 rounded-lg px-4 py-2'
                  onClick={() => {
                    setResult(false)
                  }}
                >
                  تلاش مجدد
                </Button>
              </>
            )}
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <form
        ref={form}
        action='https://sep.shaparak.ir/OnlinePG/OnlinePG'
        id='samanBank'
        method='POST'
      >
        <input name='Token' type='hidden' value={formData.token} />
        <input type='hidden' name='GetMethod' value='' />
      </form>

      <form
        action='https://bpm.shaparak.ir/pgwchannel/startpay.mellat'
        method='POST'
        id='mellat'
        ref={mellatFrom}
      >
        <input type='hidden' id='RefId' name='RefId' value={formData.token} />
        {/* <input type="text" id="MobileNo" name="MobileNo" value='989121231111' /> */}
        {/* <input type='submit' value='Submit' className='hidden' /> */}
      </form>
      <Dialog open={showConfirmModal} onOpenChange={(o) => setShowConfirmModal(o)}>
        <DialogContent>
          <DialogTitle>تایید پرداخت</DialogTitle>
          <div className='max-w-lg'>
            آیا از افزایش اعتبار به مبلغ{' '}
            <span className='text-base no-font font-bold'>
            
            {Intl.NumberFormat('fa-ir').format(increaseForm.getValues('value'))} ریال ({wordifyRialsInTomans(increaseForm.getValues('value'))}) 
            </span>
             مطمئن هستید ؟
            <br />
            <span className='font-bold'>
              توجه داشته باشید که بعد از پرداخت٫ مبلغ واریز شده قابل بازگشت به حساب شما نمی باشد.
            </span>
          </div>
          <DialogFooter className='flex flex-row gap-2'>
            <Button tabIndex={2} variant='secondary' onClick={() => setShowConfirmModal(false)}>
              لغو
            </Button>
            <Button
              tabIndex={1}
              autoFocus
              isLoading={bankIncreaseMutation.isPending}
              onClick={() => onSubmit(increaseForm.getValues())}
            >
              تایید و افزایش اعتبار
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <div className='max-w-xl mx-auto'>
        <Card>
          <CardHeader className='flex flex-row justify-between items-center'>
            <CardTitle>افزایش اعتبار</CardTitle>

            <Button variant='secondary' onClick={() => navigate({to:'/', search: {t: '', r:''}})}>
              بازگشت
            </Button>
          </CardHeader>
          <Separator className='my-4' />
          <CardContent>
          {authCheckMutation.isPending ? <div className='flex flex-col justify-center items-center'>
          <Loader2 className='animate-spin'/>
          <p className='text-center'>در حال بارگذاری ...</p>
        </div>:  <Form {...increaseForm}>
              <form onSubmit={increaseForm.handleSubmit(openModal)} className='space-y-8'>
                <FormField
                  control={increaseForm.control}
                  name='value'
                  render={({field}) => (
                    <FormItem>
                      <FormLabel>مبلغ مورد نظر خود را وارد کنید</FormLabel>
                      <FormControl>
                        <div className='relative'>
                          <div className='text-xs absolute top-3 left-2'>ریال</div>
                          <Input
                            {...field}
                            value={Intl.NumberFormat('fa-ir').format(field.value)}
                            onChange={(e) => {
                              field.onChange({
                                target: {
                                  value: Number(
                                    persianJs(e.target.value.replaceAll('٬', ''))
                                      .toEnglishNumber()
                                      .value()
                                  ),
                                },
                              })
                            }}
                            placeholder='برای مثال ۱۰۰۰ ریال'
                            dir='ltr'
                            className='text-center'
                          />

                          {increaseForm.getValues('value') > 0 && (
                            <X
                              onClick={() => increaseForm.resetField('value')}
                              className='cursor-pointer absolute right-2 top-2'
                            />
                          )}
                        </div>
                      </FormControl>
                      <FormDescription className='text-center'>
                        {wordifyRialsInTomans(increaseForm.getValues('value'))}
                      </FormDescription>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <div className='grid grid-cols-2 lg:grid-cols-5 gap-3'>
                  {[500000, 1000000, 2000000, 5000000, 10000000].map((price) => (
                    <Button
                      key={price}
                      variant='outline'
                      type='button'
                      onClick={() => increaseValue(price)}
                    >
                      {Intl.NumberFormat('fa-ir').format(price)} +
                    </Button>
                  ))}
                </div>

                <FormField
                  control={increaseForm.control}
                  name='bank'
                  render={({field}) => (
                    <FormItem>
                      <FormLabel>درگاه پرداخت مورد نظر خود را انتخاب کنید : </FormLabel>
                      <FormControl>
                      <RadioGroup
                          value={field.value}
                          onValueChange={(value) => {
                            field.onChange({target: {value}})
                          }}
                          className='flex flex-row gap-4'
                        >
                          <FormItem className={`flex flex-row items-center gap-2 ${settings && settings?.bank_default === 'saman' && settings.bank_saman_status ? 'order-1' : 'order-2'}`}>
                            <FormControl>
                              <RadioGroupItem value='saman' disabled={samanStatus ? !settings.bank_saman_status : false}></RadioGroupItem>
                            </FormControl>
                            <FormLabel className={`flex flex-row items-center gap-2 ${samanStatus ? !settings.bank_saman_status ? 'opacity-50' : '' : ''}`}>
                              <img
                                src='/media/payment/saman-bank.svg'
                                alt='bankSaman'
                                className={`size-8`}
                              />
                              <p>درگاه سامان</p>
                              {samanStatus ? !settings.bank_saman_status  ? '(غیرفعال می باشد)' : '' : ''}

                            </FormLabel>
                          </FormItem>

                          <FormItem className={`flex flex-row items-center gap-2 ${settings && settings?.bank_default === 'mellat' ? 'order-1' : 'order-2'}`}>
                            <FormLabel className={`flex flex-row items-center gap-2 ${mellatStatus ? !settings.bank_mellat_status  ? 'opacity-50' : '' : ''}`}>
                            <FormControl>
                              <RadioGroupItem value='mellat' disabled={mellatStatus ? !settings.bank_mellat_status : false}></RadioGroupItem>
                            </FormControl>
                              <img
                                src='/media/payment/mellat.png'
                                alt='bank-mellat'
                                className={`size-8`}
                              />
                              <p>درگاه ملت</p>
                              {mellatStatus ? !settings.bank_mellat_status  ? '(غیرفعال می باشد)' : '' : ''}
                            </FormLabel>
                          </FormItem>
                        </RadioGroup>
                      </FormControl>
                    </FormItem>
                  )}
                ></FormField>

                <div></div>

                <Button type='submit'>پرداخت</Button>
              </form>
            </Form>}
          </CardContent>
        </Card>
      </div>
    </>
  )
}
